import { render, staticRenderFns } from "./CostPlanning.vue?vue&type=template&id=0b030d46&scoped=true"
import script from "./CostPlanning.vue?vue&type=script&lang=js"
export * from "./CostPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b030d46",
  null
  
)

export default component.exports